import React from 'react';
import './ConnectPagesFollowUpModal.pcss';
import { ModalBody, ModalHeader } from '../modal-helpers';
import { PrimaryButton } from '../../buttons/PrimaryButton/PrimaryButton';

const helpdocLink =
  'https://mobilemonkey.com/help/article/k2f84ncs5n-i-cannot-connect-the-page';

type Props = {
  closeModal: () => void;
};

export const ConnectPagesFollowUpModal = (props: Props) => {
  const { closeModal } = props;

  return (
    <div className="connect-pages-follow-up-modal">
      <ModalHeader
        className="connect-pages-follow-up-modal__header"
        childrenContainerClassName="connect-pages-follow-up-modal__heading"
      >
        Almost there!
      </ModalHeader>
      <ModalBody className="connect-pages-follow-up-modal__body">
        <p className="connect-pages-follow-up-modal__body-note">
          Now that you've added new pages, simply go through the flow again to
          connect your page. If you haven't found any pages to connect, check
          out our troubleshooting tips{' '}
          <a
            className="connect-pages-follow-up-modal__helpdoc-link"
            href={helpdocLink}
            target="_blank"
          >
            here
          </a>
        </p>
        <div className="connect-pages-follow-up-modal__button-container">
          <PrimaryButton
            className="connect-pages-follow-up-modal__next"
            onClick={closeModal}
          >
            Ok
          </PrimaryButton>
        </div>
      </ModalBody>
    </div>
  );
};
